export default __webpack_public_path__ + "static/media/2.1c3a773c.png";